import {
  SET_TOKEN,
  SET_USER,
  LOGOUT,
  SET_USER_DETAIL,
  SET_TICKET_TEMPLATE,
  SET_USER_BY_TEAM,
  SET_VIEW_BILL_DETAIL
} from "./types";
import * as dashboard from "@/services/dashboard";

export default {
  async getBillTrend({ commit }, data) {
    const resp = await dashboard.getBillTrend(data);
    commit("BillTrend", resp.data);
  },
  async getDailyUsage({ commit }, data) {
    const resp = await dashboard.getDailyUsage(
      data.slNo,
      data.startDate,
      data.endDate
    );
    commit("DailyUsage", resp.data);
  },
  logout({ commit }) {
    commit(LOGOUT);
  },
  setUserDetail({ commit }, data) {
    commit(SET_USER_DETAIL, data);
  },

  //INVOICE
  async getInvoiceList({ commit }, data) {
    const resp = await dashboard.getInvoiceList(data);
    commit("InvoiceList", resp.data.pageItems);
  },
  async generateInvoice({ commit }, data) {
    const resp = await dashboard.createInvoice(data.clientId, data.data);
    return resp;
  },
  async createOrder({ commit }, data) {
    const resp = await dashboard.createOrder(data);
    return resp.data;
  },

  //TOPUP
  async getTopup({ commit }, data) {
    const resp = await dashboard.getTopup(data);
    commit("topupList", resp.data);
  },
  async getTicketList({ commit }, data) {
    const resp = await dashboard.getTicketList(data);
    commit("TicketList", resp.data);
  },
  setViewBillDetail({ commit }, data) {
    commit(SET_VIEW_BILL_DETAIL, data);
  },

  // MANAGE SERVICE
  async getManageServiceList({ commit }, data) {
    const resp = await dashboard.getManageServiceList(
      data.id,
      data.clientId,
      data.clientServiceId,
      data.planPoId
    );
    commit("manageServiceList", resp.data.planData);
  },
  //payments
  async getPaymentList({ commit }, data) {
    const resp = await dashboard.getPaymentList(data);
    commit("PaymentList", resp.data.pageItems);
  },
  async getTransactionList({ commit }, data) {
    const resp = await dashboard.getTransactionList(data);
    commit("TransactionList", resp.data.pageItems);
  },

  //HELP
  async setTicketTemplate({ commit }, data) {
    const response = await dashboard.getTicketTemplate();
    commit(SET_TICKET_TEMPLATE, response.data);
    return response;
  },
  async getUserByTeam({ commit }, id) {
    const resp = await dashboard.userByTeam(id);
    commit(SET_USER_BY_TEAM, resp.data.teamUsers);
    return resp;
  },
  async updateTicket({ commit }, data) {
    const res = await dashboard.ticketUpdate(data.clientId, data.data);
    return res;
  },
  async updateTicketTemplate({ commit }, data) {
    const res = await dashboard.createTicketUpdate(data.clientId, data.data);
    return res;
  },
  async createTicketDocAction({ commit }, data) {
    try {
      await cerateTicketsDocument(data.id, data.data);
    } catch (error) {
      throw error;
    }
  },
  async updatePlan({ commit }, data) {
    const res = await dashboard.planUpdate(data.clientId, data.data);
    return res;
  },
  async setRedeem({ commit }, data) {
    const res = await dashboard.getRedeem(data);
    return res;
  },
  async setTicketById({ commit }, data) {
    const resp = await dashboard.getEditTicketById(data.clientId, data.id);
    commit(types.SET_TICKET_BY_ID, resp.data);
    return resp;
  },
  async getInvoicesDetails({ commit }, data) {
    const resp = await dashboard.getInvoicesDetails(data);
    commit("InvoList", resp.data);
  }
};
